import { fetchWithHandling } from "../../utils/ApiUtils";


const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api/';


//get roles
export async function getRoles() {
    return await fetchWithHandling(`${BASE_URL}roles`, {
        credentials: 'include'
    });
}